import {combineReducers, configureStore} from '@reduxjs/toolkit';
import userReducers from './Reducers/userReducers';
import orgReducers from './Reducers/orgReducers';

const rootReducer = combineReducers({
  users: userReducers,
  organizations: orgReducers
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
